import { bunja } from 'bunja';
import type { Store } from 'jotai/vanilla/store';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import type { FixedTableTopicEvents } from '../../types';
import { weakR230522SocketBunja } from '../weak';

export function createTableAccumulatorBunja<T extends keyof FixedTableTopicEvents>(
  topic: T,
  getAccumulator: (store: Store) => (eventData: FixedTableTopicEvents[T]['data']) => void,
) {
  return bunja(() => {
    // table accumulator bunja는 웹소켓 구독을 트리거하지 않음에 유의
    const { r230522Socket } = bunja.use(weakR230522SocketBunja);
    const store = bunja.use(JotaiStoreScope);
    bunja.effect(() => {
      const accumulator = getAccumulator(store);
      const handler = (event: FixedTableTopicEvents[T]) => {
        if (!event.data) return;
        accumulator(event.data);
      };
      r230522Socket.on(topic, handler);
      return () => r230522Socket.off(topic, handler);
    });
  });
}
